/**
 * Print Styles
 * Clean, optimized styles for printing financial reports
 * Import this in App.tsx or include in global styles
 */
import { createGlobalStyle } from "styled-components";

export const PrintStyles = createGlobalStyle`
  @media print {
    /* Hide navigation and non-essential UI */
    nav,
    header,
    footer,
    aside,
    [data-print="hide"],
    .sidebar,
    .navigation,
    /* Specific app components */
    [data-testid="web-navigation"],
    [data-testid="skip-link"],
    [data-testid="environment-switcher"],
    .toast-container,
    button:not([data-print="show"]),
    .skip-link,
    .modal-backdrop {
      display: none !important;
    }

    /* Reset colors for print */
    body {
      background: white !important;
      color: black !important;
      font-size: 12pt !important;
      line-height: 1.4 !important;
    }

    /* Expand content to full width and reset AppLayout structures */
    #root, 
    #root > div,
    main,
    [data-print="main"],
    .content,
    .page-content {
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      padding: 0 !important;
      display: block !important;
    }

    /* Force reset MainContent margin */
    /* Link with App.tsx styled component */
    div[class*="MainContent"] {
      margin-left: 0 !important;
      padding: 20px !important;
    }

    /* Ensure tables print well */
    table {
      border-collapse: collapse !important;
      width: 100% !important;
    }

    th, td {
      border: 1px solid #ccc !important;
      padding: 8px !important;
      text-align: left !important;
    }

    th {
      background-color: #f5f5f5 !important;
      font-weight: bold !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    /* Charts and visualizations */
    .chart-container,
    [data-print="chart"] {
      page-break-inside: avoid !important;
      max-width: 100% !important;
    }

    /* DataTable specific resets */
    div[class*="TableContainer"] {
      max-height: none !important;
      overflow: visible !important;
      border: none !important;
    }

    thead {
      display: table-header-group !important;
    }

    tr {
      page-break-inside: avoid !important;
    }

    /* Cards and sections */
    .card,
    [data-print="section"] {
      page-break-inside: avoid !important;
      border: 1px solid #ddd !important;
      margin-bottom: 16px !important;
      padding: 16px !important;
    }

    /* Links show URLs */
    a[href]:after {
      content: " (" attr(href) ")";
      font-size: 10pt;
      color: #666;
    }

    a[href^="#"]:after,
    a[href^="javascript"]:after {
      content: "" !important;
    }

    /* Page breaks */
    h1, h2 {
      page-break-after: avoid !important;
    }

    h1, h2, h3, h4 {
      page-break-after: avoid !important;
    }

    img, table, figure {
      page-break-inside: avoid !important;
    }

    /* Print header/footer */
    @page {
      margin: 1.5cm;
      size: A4;
    }

    /* Financial amounts styling */
    .amount-positive {
      color: #059669 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .amount-negative {
      color: #DC2626 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    /* Data tables specific */
    .transaction-table,
    .holdings-table {
      font-size: 10pt !important;
    }

    /* Summary sections */
    .summary-card {
      background: #f9f9f9 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`;

export default PrintStyles;
